"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSliceReducer = createSliceReducer;

var _createLeafReducer = require("../internal/create-leaf-reducer");

var _deprecated = require("../deprecated.util");
/**
 * Creates a reducer for the given sliceName
 * ActionReducers can be added to the reducer using the addActionReducerMap function
 */
// for backward compatibility


function createSliceReducer(sliceName, initialState) {
  (0, _deprecated.deprecated)('createSliceReducer() is deprecated, use createLeafReducer()');
  return (0, _createLeafReducer.createLeafReducer)(null, sliceName, initialState);
}